import About from "./About";
import "./App.css";
// import Blog from "./Blog";
import Contact from "./Contact";
import Footer from "./Footer";
// import Link from "./Link";
import Home from "./Home";
import Project from "./Project";
import Service from "./Service";

function App() {
  return (
    <div className="App">
       <Home />
       <About />
       <Service />
       <Project /> 
       <Contact /> 
       <Footer />
    </div>
  );
}

export default App;
